module.exports = __webpack_public_path__ + "img/6.325bb461.webp";